//header-sticky-js
$(window).scroll(function(){
    if ($(window).scrollTop() >= 1) {
        $('.header').addClass('sticky');
    }
    else {
        $('.header').removeClass('sticky');
    }

});


// MOBILE MENU
$(document).ready(function() {
    $('.menu-bar').on('click', function() {
        $(this).toggleClass('in').parents('body').toggleClass('mobile-menu');
        $(this).next().toggleClass('in');
    });
    $('.mobile-scroll li.menu-item-has-children').on('click', function() {
        var aftercl = psuedoClick(this);
        var clickafter = psuedoClick(this).after;
        if (clickafter == true) {
            console.log($(aftercl));
            if (!$(this).hasClass('open')) {
                $(this).addClass('open');
                $(this).children('ul').addClass('in');
            } else {
                $(this).find('.sub-menu').removeClass('in');
                $(this).removeClass('open');
                $(this).find('li.open').removeClass('open');
            }
        }
        $('.sub-menu .sub-menu.in li.open').click(function() {
            $(this).removeClass('open');
            $(this).children('.sub-menu.in').removeClass('in');
        })
        console.log($(this).children('.sub-menu'));
    });

    $(document).bind('click', function(e) {
        var $clicked = $(e.target);
        if (!$clicked.parents().hasClass('main-nav')) {
            $('.main-nav').find('.in').removeClass('in');
            $('body').removeClass('mobile-menu');
        }
    });
});
function psuedoClick(parentElem) {

    var beforeClicked,
      afterClicked;

  var parentLeft = parseInt(parentElem.getBoundingClientRect().left, 10),
      parentTop = parseInt(parentElem.getBoundingClientRect().top, 10);

  var parentWidth = parseInt(window.getComputedStyle(parentElem).width, 10),
      parentHeight = parseInt(window.getComputedStyle(parentElem).height, 10);

  var before = window.getComputedStyle(parentElem, ':before');

  var beforeStart = parentLeft + (parseInt(before.getPropertyValue("left"), 10)),
      beforeEnd = beforeStart + parseInt(before.width, 10);

  var beforeYStart = parentTop + (parseInt(before.getPropertyValue("top"), 10)),
      beforeYEnd = beforeYStart + parseInt(before.height, 10);

  var after = window.getComputedStyle(parentElem, ':after');

  var afterStart = parentLeft + (parseInt(after.getPropertyValue("left"), 10)),
      afterEnd = afterStart + parseInt(after.width, 10);

  var afterYStart = parentTop + (parseInt(after.getPropertyValue("top"), 10)),
      afterYEnd = afterYStart + parseInt(after.height, 10);

  var mouseX = event.clientX,
      mouseY = event.clientY;

  beforeClicked = (mouseX >= beforeStart && mouseX <= beforeEnd && mouseY >= beforeYStart && mouseY <= beforeYEnd ? true : false);

  afterClicked = (mouseX >= afterStart && mouseX <= afterEnd && mouseY >= afterYStart && mouseY <= afterYEnd ? true : false);

  return {
    "before" : beforeClicked,
    "after"  : afterClicked

  };

}

//Back to top //
   $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('#back-to-top').fadeIn();
        } else {
            $('#back-to-top').fadeOut();
        }
    });

// scroll body to 0px on click
    $('#back-to-top').click(function () {
        $('#back-to-top').tooltip('hide');
        $('body,html').animate({
            scrollTop: 0
        }, 900);
        return false;
});

// Reviews slider on home page
$('.bestsellers-carousel').owlCarousel({
    loop:false,
    margin: 34,
    items:4,
    nav:true,
    dots:false,
    autoplay:false,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    navText: [
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
    responsive:{
        0:{
            items:1,
            margin: 0,
        },
        575:{

            items:2,
            margin: 20,
        },
        768:{

            items:2,
            margin: 20,
        },
        992:{
            items:3,
            margin: 20,
        },
        1200:{
            items:4
        },
        1400:{
            items:4
        }
    }
})


// Testimonials slider on home page
$('.testimonials-carousel').owlCarousel({
    loop:true,
    margin: 86,
    items:3,
    nav:true,
    dots:false,
    autoplay:false,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    navText: [
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
    responsive:{
        0:{
            items:1,
            margin: 0,
        },
        575:{

            items:2,
            margin: 20,
        },
        768:{

            items:2,
            margin: 30,
        },
        992:{
            items:3,
            margin: 40,
        },
        1400:{
            items:3,
            margin: 50,
        },
        1681:{
            margin: 86,
        }

    }
})

// hero top banner slider on home page
$('.heroslider-carousel').owlCarousel({
    loop:false,
    margin: 0,
    items:1,
    nav:false,
    dots:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    navText: [
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
    responsive:{
        0:{
            items:1,
            margin: 0,
        },
        575:{

            items:1,
            margin: 0,
        },
        768:{

            items:1,
            margin: 0,
        },
        992:{
            items:1
        },
        1400:{
            items:1
        }
    }
})

// Shop by category slider on home page
$('.shopbycategory-carousel').owlCarousel({
    loop:true,
    margin: 54,
    items:5,
    nav:false,
    dots:true,
    autoplay:true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    freeDrag: false,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    navText: [
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
    '<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>'],
    responsive:{
        0:{
            items:1.5,
            margin: 10,
        },
        575:{

            items:3,
            margin: 15,
        },
        768:{

            items:3,
            margin: 30,
        },
        992:{
            items:4,
            margin: 40,
        },
        1400:{
            items:5,
            margin: 54,
        }
    }
})
/*============equalizeHeightsByRow========*/
function equalizeHeightsByRow(e) {
   const t = Array.from(document.querySelectorAll(e));
   let o = [];
   t.forEach(e => {
      e.style.height = "auto";
      const t = e.getBoundingClientRect().top;
      let a = o.find(e => Math.abs(e.top - t) < 1);
      a || (a = {
         top: t,
         elements: []
      }, o.push(a)), a.elements.push(e)
   }), o.forEach(e => {
      let t = 0;
      e.elements.forEach(e => {
         e.offsetHeight > t && (t = e.offsetHeight)
      }), e.elements.forEach(e => {
         e.style.height = t + "px"
      })
   })
}
window.addEventListener("load", () => {
   equalizeHeightsByRow(".stepbystep-col h3"),
   equalizeHeightsByRow(".blog-post-content h3")   
})

//Video section
const video = document.getElementById("video");
const circlePlayButton = document.getElementById("circle-play-b");

function togglePlay() {
	if (video.paused || video.ended) {
		video.play();
	} else {
		video.pause();
	}
}

circlePlayButton.addEventListener("click", togglePlay);
video.addEventListener("playing", function () {
	circlePlayButton.style.opacity = 0;
});
video.addEventListener("pause", function () {
	circlePlayButton.style.opacity = 1;
});


const playBtn = document.getElementById("circle-play-b");
const iframe = document.getElementById("video");

playBtn.addEventListener("click", function () {
    let src = iframe.src;

    if (!src.includes("autoplay=1")) {
        iframe.src = src + (src.includes("?") ? "&" : "?") + "autoplay=1";
    }

    this.style.display = "none";
});